<div class="overflow-auto table-content" (scroll)="scrollTable($event)"
     [ngClass]="{'table-content-with-tabs': (url?.includes('complaints/list') || url.includes('content/list'))}">
  <div class="bg-app-bar px-6 h-16 border-b sticky table-header flex items-center ltr:left-0" id="table-bar"
       [ngClass]="{'p-0': isMobile}">
    <h2 class="title my-0 ltr:pr-4 rtl:pl-4 ltr:mr-4 rtl:ml-4 ltr:border-r rtl:border-l hidden sm:block flex-none">
      <span *ngIf="selection.isEmpty()">{{pluralTableLabel | translate}}</span>
      <span *ngIf="selection.hasValue()">{{ isAllSelected() ? dataSource.data.length : selection.selected.length }}
        {{ (selection.selected.length > 1 ? pluralTableLabel : singleTableLabel) | translate}}<span
          *ngIf="selection.selected.length > 1"></span> {{'selected' | translate}}</span>
    </h2>

    <div *ngIf="selection.hasValue()"
         class="mr-4 pr-4 border-r flex-none flex justify-content-center align-items-center">
      <button (click)="delete(selection.selected)"
              *ngIf="hasDelete"
              color="primary"
              mat-icon-button
              tooltip="{{'Delete selected' | translate}}"
              type="button">
        <mat-icon svgIcon="mat:delete"></mat-icon>
      </button>

      <button (click)="exportExcel('select')" color="primary" mat-icon-button
              tooltip="{{'Export selected' | translate}}" type="button">
        <mat-icon svgIcon="mat:cloud_download"></mat-icon>
      </button>

      <!--      <button (click)="certificateIssuance(selection.selected)" color="primary" mat-icon-button-->
      <!--              tooltip="{{'Certificate issuance' | translate}}" type="button">-->
      <!--        <mat-icon svgIcon="mat:ios_share"></mat-icon>-->
      <!--      </button>-->

      <!--      <button (click)="certificateShare(selection.selected)" color="primary" mat-icon-button-->
      <!--              tooltip="{{'Share Certificate' | translate}}" type="button">-->
      <!--        <mat-icon svgIcon="mat:campaign"></mat-icon>-->
      <!--      </button>-->

      <button (click)="editWeights(selection.selected)" color="primary" mat-icon-button
              *ngIf="pluralTableLabel === 'Content plannings'"
              tooltip="{{'Edit weights' | translate}}" type="button">
        <mat-icon svgIcon="mat:scale"></mat-icon>
      </button>

      <button (click)="editQuestions(selection.selected)" color="primary" mat-icon-button
              *ngIf="pluralTableLabel === 'Questions' && url.includes('exam')"
              tooltip="{{'Edit Questions' | translate}}" type="button">
        <mat-icon svgIcon="mat:scale"></mat-icon>
      </button>

      <button (click)="addInExamFromBank(selection.selected)" color="primary" mat-icon-button *ngIf="hasAddFromBank"
              tooltip="{{'Add to exam' | translate}}" type="button">
        <mat-icon svgIcon="mat:add"></mat-icon>
      </button>

      <button *ngIf="pluralTableLabel === 'Users'" (click)="sendNotification()"
              color="primary" mat-icon-button
              tooltip="{{'Send notification' | translate}}" type="button">
        <mat-icon style="font-size: 18px" svgIcon="mat:notification_add"></mat-icon>
      </button>
    </div>


    <button (click)="downloadImportStudentsFile()" color="primary" mat-icon-button
            *ngIf="pluralTableLabel === 'Students'"
            tooltip="{{'Download Template' | translate}}" type="button">
      <mat-icon svgIcon="mat:download"></mat-icon>
    </button>

    <button (click)="importStudents()" color="primary" mat-icon-button
            *ngIf="pluralTableLabel === 'Students'"
            tooltip="{{'Import File' | translate}}" type="button">
      <mat-icon svgIcon="mat:upload_file"></mat-icon>
    </button>

    <button (click)="downloadImportTeachersFile()" color="primary" mat-icon-button
            *ngIf="pluralTableLabel === 'Teachers'"
            tooltip="{{'Download Template' | translate}}" type="button">
      <mat-icon svgIcon="mat:download"></mat-icon>
    </button>

    <button (click)="importTeachers()" color="primary" mat-icon-button
            *ngIf="pluralTableLabel === 'Teachers'"
            tooltip="{{'Import File' | translate}}" type="button">
      <mat-icon svgIcon="mat:upload_file"></mat-icon>
    </button>


    <button (click)="downloadImportQuestionsFile()" color="primary" mat-icon-button
            *ngIf="pluralTableLabel === 'Questions' && url.includes('questions-banks')"
            tooltip="{{'Download Template' | translate}}" type="button">
      <mat-icon svgIcon="mat:download"></mat-icon>
    </button>

    <button (click)="importQuestions()" color="primary" mat-icon-button
            *ngIf="pluralTableLabel === 'Questions' && url.includes('questions-banks')"
            tooltip="{{'Import File' | translate}}" type="button">
      <mat-icon svgIcon="mat:upload_file"></mat-icon>
    </button>

    <div
      class="bg-foreground rounded-full border px-4 max-w-[300px] flex-auto flex items-center border border-gray-300">
      <mat-icon class="icon-sm text-secondary" svgIcon="mat:search"></mat-icon>
      <input [formControl]="searchCtrl"
             class="px-4 py-2 border-0 outline-none w-full bg-transparent"
             placeholder="{{'Search...' | translate}}"
             type="search">
    </div>

    <span class="flex-1"></span>


    <button *ngIf="pluralTableLabel === 'Users'" (click)="sendNotification(true)"
            color="primary" mat-icon-button
            tooltip="{{'Send notification to all' | translate}}" type="button">
      <mat-icon style="font-size: 18px" svgIcon="mat:campaign"></mat-icon>
    </button>

    <button *ngIf="hasGenerateCert" (click)="generateCert()"
            color="primary" mat-icon-button
            tooltip="{{'Generate certificate' | translate}}" type="button">
      <mat-icon style="font-size: 18px" svgIcon="mat:redeem"></mat-icon>
    </button>

    <button (click)="exportExcel('all')" color="primary" mat-icon-button tooltip="{{'Export all' | translate}}"
            type="button">
      <mat-icon svgIcon="mat:cloud_download"></mat-icon>
    </button>

    <button [matMenuTriggerFor]="columnFilterMenu"
            class="ml-4 flex-none"
            mat-icon-button
            tooltip="{{'Filter Columns' | translate}}"
            type="button">
      <mat-icon svgIcon="mat:filter_list"></mat-icon>
    </button>

    <button *ngIf="hasAdd" (click)="create()"
            class="ml-4 d-flex align-items-center justify-content-center"
            color="primary"
            mat-mini-fab
            tooltip="{{'Add' | translate}} {{singleTableLabel | translate}}"
            type="button">
      <mat-icon svgIcon="mat:add"></mat-icon>
    </button>

    <button *ngIf="publishExam && selection.selected?.length" (click)="publishExamQuestions()"
            class="ml-4 d-flex align-items-center justify-content-center"
            color="primary"
            mat-button
            tooltip="{{'Publish' | translate}}"
            type="button">
      {{'Publish' | translate}}
    </button>
  </div>

  <table [@stagger]="dataSource.filteredData"
         [dataSource]="dataSource"
         class="w-full flex-auto"
         (matSortChange)="changeSort($event)"
         mat-table
         matSort>

    <!--- Note that these columns can be defined in any order.
          The actual rendered columns are set as a property on the row definition" -->

    <!-- Model Properties Column -->
    <ng-container *ngFor="let column of columns">

      <!--type text -->
      <ng-container *ngIf="column.type === 'text'" [matColumnDef]="column.property">
        <ng-container *ngIf="column.property === 'status_object'; else others">
          <th *matHeaderCellDef mat-header-cell mat-sort-header
              [disabled]="!column.hasSort"> {{ column.label | translate}}</th>
          <td *matCellDef="let row" [ngClass]="column.cssClasses"
              mat-cell><a class="teacher_badge cursor-default ltr:mr-3 rtl:ml-3"
                          [style]="{'background': row[column.property]?.color}">{{(row[column.property].text) || '-'}}</a>
          </td>
        </ng-container>
        <ng-container *ngIf="column.property === 'color'; else others">
          <th *matHeaderCellDef mat-header-cell mat-sort-header
              [disabled]="!column.hasSort"> {{ column.label | translate}}</th>
          <td *matCellDef="let row" [ngClass]="column.cssClasses"
              mat-cell><a class="teacher_badge cursor-default ltr:mr-3 rtl:ml-3"
                          [style]="{'background': row[column.property], 'width': '50%', 'height': '20px'}"></a>
          </td>
        </ng-container>
        <ng-container *ngIf="(column.property === 'from' && pluralTableLabel === 'Student records'); else others">
          <th *matHeaderCellDef mat-header-cell mat-sort-header
              [disabled]="!column.hasSort"> {{ column.label | translate}}</th>
          <td *matCellDef="let row" [ngClass]="column.cssClasses"
              tooltip="{{row.from_aya.aya_text}}"
              mat-cell>{{row[column.property]}}</td>
        </ng-container>
        <ng-container
          *ngIf="(column.property === 'session_number' && pluralTableLabel === 'Student records'); else others">
          <th *matHeaderCellDef mat-header-cell mat-sort-header
              [disabled]="!column.hasSort"> {{ column.label | translate}}</th>
          <td *matCellDef="let row" [ngClass]="column.cssClasses"
              (click)="playSessionFun(row)"
              mat-cell>{{row[column.property]}}</td>
        </ng-container>
        <ng-container *ngIf="(column.property === 'to' && pluralTableLabel === 'Student records'); else others">
          <th *matHeaderCellDef mat-header-cell mat-sort-header
              [disabled]="!column.hasSort"> {{ column.label | translate}}</th>
          <td *matCellDef="let row" [ngClass]="column.cssClasses"
              tooltip="{{row.to_aya.aya_text}}"
              mat-cell>{{row[column.property]}}</td>
        </ng-container>
        <ng-template #others>
          <ng-container>
            <th *matHeaderCellDef mat-header-cell mat-sort-header [disabled]="!column.hasSort"
                (click)="headerClicked($event)"> {{ column.label | translate}}</th>
            <td *matCellDef="let row" [ngClass]="column.cssClasses"
                tooltip="{{row[column.property]?.length > 20 ? (row[column.property]) : ''}}"
                mat-cell>{{row[column.property]?.length > 20 ? (row[column.property].slice(0, 20) + '...') : ((row[column.property]) ?? '-')}}</td>
          </ng-container>
        </ng-template>


      </ng-container>

      <!--type number-->
      <ng-container *ngIf="column.type === 'number'" [matColumnDef]="column.property">
        <th *matHeaderCellDef mat-header-cell mat-sort-header
            [disabled]="!column.hasSort"> {{ column.label | translate}}</th>
        <td *matCellDef="let row" [ngClass]="column.cssClasses"
            mat-cell>{{ row[column.property] ?? '--'  | translate}}</td>
      </ng-container>


      <!--type bool-->
      <ng-container *ngIf="column.type === 'bool'" [matColumnDef]="column.property">
        <th *matHeaderCellDef mat-header-cell mat-sort-header
            [disabled]="!column.hasSort"> {{ column.label | translate}}</th>
        <td *matCellDef="let row" [ngClass]="column.cssClasses"
            mat-cell>{{row[column.property] === 0 ? 'Yes' : 'No'  | translate}}</td>
      </ng-container>

      <!--type date-->
      <ng-container *ngIf="column.type === 'date'" [matColumnDef]="column.property">
        <th *matHeaderCellDef mat-header-cell mat-sort-header
            [disabled]="!column.hasSort"> {{ column.label | translate}}</th>
        <td *matCellDef="let row" [ngClass]="column.cssClasses"
            mat-cell>{{ (row[column.property] | customDateFormat) || '-' }}</td>
      </ng-container>

      <!--type html-->
      <ng-container *ngIf="column.type === 'html'" [matColumnDef]="column.property">
        <th *matHeaderCellDef mat-header-cell mat-sort-header
            [disabled]="!column.hasSort"> {{ column.label | translate}}</th>
        <td *matCellDef="let row" [ngClass]="column.cssClasses"
            tooltip="{{row[column.property]?.length > 40 ? (row[column.property]) : ''}}"
            mat-cell>
          <span
            [innerHTML]="row[column.property]?.length > 40 ? (row[column.property].slice(0, 40) + '...') : row[column.property]"></span>
          <mat-icon style="width: 18px;" class="mx-2"
                    [ngClass]="{'pull-left': language === 'ar', 'pull-right': language === 'en'}"
                    *ngIf="column.property === 'body'"
                    (click)="copyMessage(row[column.property])" svgIcon="mat:content_copy"></mat-icon>
        </td>
      </ng-container>

      <!--type menu-->
      <ng-container *ngIf="column.type === 'menu'" [matColumnDef]="column.property">
        <th *matHeaderCellDef mat-header-cell mat-sort-header
            [disabled]="!column.hasSort"> {{ column.label | translate}}</th>
        <td *matCellDef="let row" [ngClass]="column.cssClasses"
            [innerHTML]="row[column.property]"
            mat-cell></td>
      </ng-container>

      <!--type multiple_text-->
      <ng-container *ngIf="column.type === 'multiple_text'" [matColumnDef]="column.property">
        <th *matHeaderCellDef mat-header-cell mat-sort-header
            [disabled]="!column.hasSort"> {{ column.label | translate}}</th>
        <td *matCellDef="let row" [ngClass]="column.cssClasses"
            mat-cell><a class="teacher_badge ltr:mr-3 rtl:ml-3"
                        routerLink="/admin-management/teachers/{{teacher?.teacher_id}}"
                        target="_blank"
                        [style]="{'background': teacher?.status_object?.color}"
                        [tooltip]="teacher?.status_object?.text"
                        *ngFor="let teacher of row[column.property]">{{teacher?.status_object?.teacher_name}}</a></td>
      </ng-container>

      <!--type badge-->
      <ng-container *ngIf="column.type === 'badge'" [matColumnDef]="column.property">
        <th *matHeaderCellDef mat-header-cell mat-sort-header
            [disabled]="!column.hasSort"> {{ column.label | translate}}</th>
        <td *matCellDef="let row" [ngClass]="column.cssClasses" mat-cell>
          <div *ngIf="row[column.property] === 'ready'"
               class="w-3 h-3 rounded-full bg-green cursor-pointer"
               tooltip="Ready to ship"></div>
          <div *ngIf="row[column.property] === 'pending'"
               class="w-3 h-3 rounded-full bg-orange cursor-pointer"
               tooltip="Pending Payment"></div>
          <div *ngIf="row[column.property] === 'warn'"
               class="w-3 h-3 rounded-full bg-red cursor-pointer"
               tooltip="Missing Payment"></div>
        </td>
      </ng-container>

      <!-- type Checkbox -->
      <ng-container *ngIf="column.type === 'checkbox'" [matColumnDef]="column.property" sticky>
        <th *matHeaderCellDef mat-header-cell>
          <mat-checkbox (change)="$event ? masterToggle() : null"
                        [checked]="selection.hasValue() && isAllSelected()"
                        [indeterminate]="selection.hasValue() && !isAllSelected()"
                        color="primary">
          </mat-checkbox>
        </th>
        <td *matCellDef="let row" class="w-4" mat-cell>
          <mat-checkbox (change)="$event ? selection.toggle(row) : null"
                        (click)="$event.stopPropagation()"
                        [checked]="selection.isSelected(row)"
                        color="primary">
          </mat-checkbox>
        </td>
      </ng-container>

      <!-- type image-->
      <ng-container *ngIf="column.type === 'image'" [matColumnDef]="column.property">
        <th *matHeaderCellDef mat-header-cell> {{ column.label | translate}}</th>
        <td *matCellDef="let row" [ngClass]="column.cssClasses" mat-cell>
          <img [imageViewer]="row[column.property] ? row[column.property] : defaultAvatar"
               [attr.src]="row[column.property] ? row[column.property] : defaultAvatar"
               class="avatar h-9 w-9 align-middle" alt="CIB-OAP image">
        </td>
      </ng-container>

      <!-- type button-->
      <ng-container *ngIf="column.type === 'button'" [matColumnDef]="column.property" stickyEnd>
        <ng-container *ngIf="column.property === 'cert_issuance'">
          <th *matHeaderCellDef mat-header-cell> {{ column.label | translate }}</th>
          <td *matCellDef="let row" [ngClass]="column.cssClasses" class="w-10" mat-cell>
            <button (click)="$event.stopPropagation(); certificateIssuance([row])"
                    color="primary" mat-icon-button
                    tooltip="{{'Issue' | translate}}" type="button">
              {{'Issue' | translate}}
            </button>
          </td>
        </ng-container>
        <ng-container *ngIf="column.property === 'view_cert'">
          <th *matHeaderCellDef mat-header-cell> {{ column.label | translate }}</th>
          <td *matCellDef="let row" [ngClass]="column.cssClasses" class="w-10" mat-cell>
            <button (click)="$event.stopPropagation(); certificateView(row)"
                    color="primary" mat-icon-button
                    tooltip="{{'View' | translate}}" type="button">
              {{'View' | translate}}
            </button>
          </td>
        </ng-container>
        <ng-container *ngIf="column.property === 'share_cert'">
          <th *matHeaderCellDef mat-header-cell> {{ column.label | translate }}</th>
          <td *matCellDef="let row" [ngClass]="column.cssClasses" class="w-10" mat-cell>
            <button (click)="$event.stopPropagation(); certificateShare([row])"
                    color="primary" mat-icon-button
                    tooltip="{{'Send' | translate}}" type="button">
              {{'Send' | translate}}
            </button>
          </td>
        </ng-container>
        <ng-container *ngIf="column.property === 'resend'">
          <th *matHeaderCellDef mat-header-cell> {{ column.label | translate }}</th>
          <td *matCellDef="let row" [ngClass]="column.cssClasses" class="w-10" mat-cell>
            <button (click)="resendNotification(row)"
                    color="primary" mat-icon-button
                    tooltip="{{'Resend notification' | translate}}" type="button">
              <i style="font-size: 18px" class="fa fa-send-o"></i>
            </button>
          </td>
        </ng-container>
        <ng-container *ngIf="column.property === 'view_images'">
          <th *matHeaderCellDef mat-header-cell> {{ column.label | translate }}</th>
          <td *matCellDef="let row" [ngClass]="column.cssClasses" class="w-10" mat-cell>
            <button (click)="viewScreenshots(row)"
                    color="primary" mat-icon-button
                    tooltip="{{'View screenshots' | translate}}" type="button">
              <mat-icon style="font-size: 18px" svgIcon="mat:visibility"></mat-icon>
            </button>
          </td>
        </ng-container>
        <ng-container *ngIf="column.property === 'menu'">
          <th *matHeaderCellDef mat-header-cell> {{ column.label | translate }}</th>
          <td *matCellDef="let row" [ngClass]="column.cssClasses" style="background: #fff" class="w-10 rtl:left-0"
              mat-cell>
            <button (click)="$event.stopPropagation(); selectedRow = row"
                    [matMenuTriggerFor]="actionMenu"
                    mat-icon-button
                    type="button">
              <mat-icon svgIcon="mat:more_vert"></mat-icon>
            </button>
          </td>
        </ng-container>
        <ng-container *ngIf="column.property === 'record_url'">
          <th *matHeaderCellDef mat-header-cell mat-sort-header
              [disabled]="!column.hasSort"> {{ column.label | translate }}</th>
          <td *matCellDef="let row" class="{{column.cssClasses}} w-10" [ngClass]="{'disabled-td': !row.record_url}"
              (click)="playSessionFun(row)"
              mat-cell>
            <mat-icon svgIcon="mat:smart_display"></mat-icon>
          </td>
        </ng-container>
        <ng-container *ngIf="column.property === 'status'">
          <th *matHeaderCellDef mat-header-cell mat-sort-header
              [disabled]="!column.hasSort"> {{ column.label | translate }}</th>
          <!--          <td *matCellDef="let row" [style.color]="row[column.property]?.color" [ngClass]="column.cssClasses"-->
          <!--              class="w-10" mat-cell>{{(row[column.property]?.name) || row[column.property]}}</td>-->
          <td *matCellDef="let row" [style.color]="row[column.property]?.color" [ngClass]="column.cssClasses"
              class="w-10" mat-cell>
            <button (click)="$event.stopPropagation(); selectedRow = row"
                    [matMenuTriggerFor]="statusMenu"
                    mat-icon-button
                    type="button">
              {{(row[column.property]?.name) || row[column.property] | translate}}
            </button>
          </td>
        </ng-container>
      </ng-container>
    </ng-container>


    <tr *matHeaderRowDef="visibleColumns; sticky: true" mat-header-row></tr>
    <!--suppress UnnecessaryLabelJS -->
    <tr *matRowDef="let row; columns: visibleColumns;"
        @fadeInUp
        [ngClass]="{'selected': selection.isSelected(row)}"
        (click)="rowClicked(row)"
        class="hover:bg-hover cursor-pointer"
        mat-row></tr>
  </table>

  <div *ngIf="dataSource.filteredData.length === 0 && !loading"
       @scaleFadeIn
       class="flex-auto flex flex-col items-center justify-center">
    <img class="m-12 h-64" src="assets/img/illustrations/idea.svg">
    <h2
      class="headline m-0 text-center mb-5">{{(filtering ? 'No data matching your filters' : 'No data available') | translate}}</h2>
  </div>

  <mat-paginator [class.hidden]="dataSource.filteredData.length === 0"
                 [pageSize]="pageSize"
                 [length]="total"
                 [showFirstLastButtons]="true"
                 [pageSizeOptions]="pageSizeOptions"
                 (page)="changePage($event)"
                 id="paginator"
                 class="sticky bottom-0 ltr:left-0 rtl:right-0 table-paginator border-t flex-none"></mat-paginator>
</div>
<mat-menu #actionMenu="matMenu" xPosition="before" yPosition="below">
  <button mat-menu-item *ngIf="hasModify" [disabled]="disableEdit()"
          (click)="openRow.emit(selectedRow)">
    <mat-icon svgIcon="mat:edit"></mat-icon>
    <span>{{'Modify' | translate}}</span>
  </button>

  <button mat-menu-item *ngIf="hasDelete" [disabled]="disableDelete()"
          (click)="deleteData.emit(selectedRow)">
    <mat-icon svgIcon="mat:delete_forever"></mat-icon>
    <span>{{'Delete' | translate}}</span>
  </button>

  <button mat-menu-item *ngIf="hasAddToPassedUsers && !selectedRow?.is_passed"
          (click)="addToPassedUsersEmitter.emit(selectedRow)">
    <mat-icon svgIcon="mat:check_box"></mat-icon>
    <span>{{'Add to Passed Users' | translate}}</span>
  </button>


  <button mat-menu-item *ngIf="hasRemoveFromPassedUsers"
          (click)="removeFromPassedUsersEmitter.emit(selectedRow)">
    <mat-icon svgIcon="mat:person_remove"></mat-icon>
    <span>{{'Remove from Passed Users' | translate}}</span>
  </button>


  <button mat-menu-item *ngIf="hasViewCert"
          (click)="viewCertEmitter.emit(selectedRow)">
    <mat-icon svgIcon="mat:visibility"></mat-icon>
    <span>{{'View certificate' | translate}}</span>
  </button>


  <button mat-menu-item *ngIf="hasRecord"
          (click)="openFile(selectedRow)">
    <mat-icon svgIcon="mat:receipt_long"></mat-icon>
    <span>{{'Student record' | translate}}</span>
  </button>

  <button mat-menu-item *ngIf="hasView"
          (click)="view(selectedRow)">
    <mat-icon svgIcon="mat:visibility"></mat-icon>
    <span>{{'View' | translate}}</span>
  </button>

  <button mat-menu-item *ngIf="hasTransfer"
          (click)="transferToSupportTicket(selectedRow)">
    <mat-icon svgIcon="mat:move_up"></mat-icon>
    <span>{{'Transfer to support ticket' | translate}}</span>
  </button>

  <button mat-menu-item *ngIf="hasTransferToSupportType"
          (click)="transferToAnotherSupportType(selectedRow)">
    <mat-icon svgIcon="mat:move_up"></mat-icon>
    <span>{{'Transfer to another type' | translate}}</span>
  </button>

  <button mat-menu-item *ngIf="hasReply"
          (click)="reply(selectedRow)">
    <mat-icon svgIcon="mat:visibility"></mat-icon>
    <span>{{'Reply' | translate}}</span>
  </button>

  <button mat-menu-item *ngIf="hasPlay"
          [disabled]="!selectedRow?.video_url"
          (click)="playSessionFun(selectedRow)">
    <mat-icon svgIcon="mat:smart_display"></mat-icon>
    <span>{{'Play session' | translate}}</span>
  </button>

  <button mat-menu-item *ngIf="hasContent"
          (click)="gotoContent(selectedRow)">
    <mat-icon svgIcon="mat:settings"></mat-icon>
    <span>{{'Course content' | translate}}</span>
  </button>

  <button mat-menu-item *ngIf="hasAnswers"
          (click)="gotoAnswers(selectedRow)">
    <mat-icon svgIcon="mat:verified"></mat-icon>
    <span>{{'View answers' | translate}}</span>
  </button>

  <button mat-menu-item *ngIf="hasPromoCodes"
          (click)="gotoPromoCodes(selectedRow)">
    <mat-icon svgIcon="mat:redeem"></mat-icon>
    <span>{{'Promo codes' | translate}}</span>
  </button>

  <button mat-menu-item *ngIf="hasPublish"
          (click)="publish(selectedRow)">
    <mat-icon svgIcon="mat:publish"></mat-icon>
    <span>{{(selectedRow?.status === 2 ? 'UnPublish' : 'Publish') | translate}}</span>
  </button>

  <button mat-menu-item *ngIf="hasAddQuestions"
          (click)="gotoQuestions(selectedRow)">
    <mat-icon svgIcon="mat:settings"></mat-icon>
    <span>{{'Manage' | translate}}</span>
  </button>

  <button mat-menu-item *ngIf="hasManagePerformance"
          (click)="gotoPerformance(selectedRow)">
    <mat-icon svgIcon="mat:settings"></mat-icon>
    <span>{{'Manage performance' | translate}}</span>
  </button>

  <button mat-menu-item *ngIf="hasQuestions"
          (click)="gotoQuestions(selectedRow)">
    <mat-icon svgIcon="mat:help"></mat-icon>
    <span>{{'Questions' | translate}}</span>
  </button>

  <button mat-menu-item *ngIf="hasInstructions"
          (click)="gotoInstructions(selectedRow)">
    <mat-icon svgIcon="mat:emoji_objects"></mat-icon>
    <span>{{'Instructions' | translate}}</span>
  </button>

  <button mat-menu-item *ngIf="pluralTableLabel === 'Teachers Balance'" (click)="zeroBalance.emit(selectedRow)">
    <mat-icon svgIcon="mat:exposure_zero"></mat-icon>
    <span>{{'Zero Balance' | translate}}</span>
  </button>
</mat-menu>

<mat-menu #columnFilterMenu="matMenu" xPosition="before" yPosition="below">
  <button (click)="toggleColumnVisibility(column, $event)" *ngFor="let column of filterColumns"
          class="checkbox-item mat-menu-item">
    <mat-checkbox (click)="$event.stopPropagation()" [(ngModel)]="column.visible" color="primary">
      {{ column.label | translate }}
    </mat-checkbox>
  </button>
</mat-menu>

<mat-menu #statusMenu="matMenu" xPosition="before" yPosition="below">
  <button (click)="changeStatus(status)" *ngFor="let status of statuses"
          class="checkbox-item mat-menu-item">{{status?.name | translate}}
  </button>
</mat-menu>
